export default __webpack_public_path__ + "static/media/load.87935a9a.png";